import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        step: '=',
        enableAll: '=',
        customOptions: '<',
        // true: stays visible while the next page loads, for lists that keep their table meanwhile
        keepWhileLoading: '<?'
    },
    template: `
        <div class="table-tools" ng-if="(vm.keepWhileLoading || !vm.list.loading) && vm.list.items.length">
          <small>{{ 'pagination.results' | translate:{n: vm.list.pagination.totalCount} }}</small>
          <label>
            {{ 'pagination.Show' | translate }}
            <select class="form-control"
                    ng-model="vm.perPageObj"
                    ng-change="vm.changeListSize()"
                    ng-options="item as item.label for item in vm.selectList track by item.value">
            </select>
            {{ 'pagination.entries' | translate:{n: (vm.perPageObj && vm.perPageObj.value === 0) ? 0 : 1} }}
          </label>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, lodash) {
        this.lodash = lodash;
        this.$translate = $translate;
        const listener = $scope.$watch('vm.list.loading', (oldValue, newValue) => {
            // rebuild select on first list loading in case user uses special pagesize and we need to add it to select
            if (!oldValue && newValue) {
                this.buildSelect();

                // remove event listener
                listener();
            }
        });
    }

    $onInit () {
        this.STEP_SIZE = this.step ? this.step : 25;
        this.OPTION_COUNT = this.optionCount ? this.optionCount : 4;
        this.buildSelect();
    }

    changeListSize () {
        this.list.lastQuery.pageSize = Number(this.perPageObj && this.perPageObj.value);
        this.list.lastQuery.page = 1;
        this.list.fetch();
    }

    buildSelect () {
        const currentPageSize = Number(this.list.pagination.perPage);
        let list = [];
        for (let i = 0; i < this.OPTION_COUNT; i++) {
            list.push(Math.pow(2, i) * this.STEP_SIZE);
        }
        if (currentPageSize) {
            list.push(currentPageSize);
        }
        if (this.customOptions) {
            list = list.concat(this.customOptions);
        }
        list = list
            .filter((item, i) => list.indexOf(item) === i)
            .sort((a, b) => a - b)
            .map(step => ({ value: Number(step), label: Number(step) }));
        if (this.enableAll) {
            list.push({ label: this.$translate.instant('pagination.All'), value: 0 });
        }
        this.selectList = list;

        // pick the exact object instance as the model
        const match = this.selectList.find(o => o.value === currentPageSize);
        this.perPageObj = match || (this.selectList.length ? this.selectList[0] : null);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/pagination/tools/index.js